<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->


<template>

    <BasePage :header="header" :tabs="tabs" v-model:activeTab="activeTab">

        <!-- OVERVIEW -->
        <template #tab-overview>
            <slot name="overview" :rows="rows" :loading="loading" :select="selectRow" />
        </template>

        <!-- CREATE -->
        <template #tab-create>
            <slot name="create" :createModel="createModel" :create="create" />
        </template>

        <!-- INSPECT -->
        <template #tab-inspect>
            <slot name="inspect" :selected="selected" :model="editModel" :update="update" />
        </template>

        <!-- HISTORY -->
        <template #tab-history>
            <slot name="history" :selected="selected" />
        </template>

    </BasePage>

</template>


<script setup>

import { ref } from "vue"
import { useRoute } from "vue-router"

const route = useRoute()

const props = defineProps({

    rows: Array,
    loading: Boolean,

    createModel: Object,

    create: Function,
    update: Function

})

const activeTab = ref("overview")

const selected = ref(null)

const editModel = ref(null)

const header = route.meta.header

const tabs = [

    { key: "overview", label: "Overview" },
    { key: "create", label: "Create" },
    { key: "inspect", label: "Inspect" },
    { key: "history", label: "History" }

]

function selectRow(row) {

    selected.value = row

    editModel.value = { ...row }

    activeTab.value = "inspect"

}

</script>